<template lang="pug">
  div.container-fluid.background-login.vertical-center.px-0
    div.row.d-flex.justify-content-center
      div.col-12.col-sm-12.col-md-6.col-lg-6
        div.card
          div.spinner.spinner-border.spinner-border-lg.text-primary(v-if="verifying")
          div.card-header
            | E-Mail-Verifizierung
          div.card-body.text-center
            // Verifying state
            div(v-if="verifying")
              h5 Verifizierung läuft...
              p Bitte warten Sie, während wir Ihre E-Mail-Adresse verifizieren.

            // Success state
            div.alert.alert-success(v-else-if="verificationSuccess")
              div.emoji-icon.mb-3 ✅
              h5 Verifizierung erfolgreich!
              p Ihre E-Mail-Adresse wurde erfolgreich verifiziert.
              p Ihre Registrierung wird nun von unserem Team geprüft. Sie erhalten eine E-Mail, sobald Ihr Schülerkonto freigegeben wurde.

            // Error state
            div.alert.alert-danger(v-else-if="verificationError")
              div.emoji-icon.mb-3 ❌
              h5 Verifizierung fehlgeschlagen
              p {{ errorMessage }}
              button.btn.btn-primary.mt-3(
                type="button"
                @click="$router.push('/student-registrierung')"
              )
                | Zur Registrierung

            // Invalid token state
            div.alert.alert-warning(v-else)
              div.emoji-icon.mb-3 ⚠️
              h5 Ungültiger Link
              p Der Verifizierungslink ist ungültig oder abgelaufen.
              button.btn.btn-primary.mt-3(
                type="button"
                @click="$router.push('/student-registrierung')"
              )
                | Zur Registrierung
</template>

<style scoped>
.background-login {
  min-height: 100vh;
}

.vertical-center {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.card {
  position: relative;
}
</style>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'StudentVerification',
  data () {
    return {
      verifying: false,
      verificationSuccess: false,
      verificationError: false,
      errorMessage: ''
    }
  },
  mounted () {
    this.verifyEmail()
  },
  methods: {
    ...mapActions('orderFormService', ['verifyStudentEmail']),
    async verifyEmail () {
      const token = this.$route.params.token

      if (!token) {
        this.verificationError = true
        this.errorMessage = 'Kein Verifizierungstoken gefunden'
        return
      }

      this.verifying = true

      try {
        const requestData = {
          token: token
        }

        const success = await this.verifyStudentEmail(requestData)

        if (success) {
          const response = this.$store.state.orderFormService.latestRequests.verifyStudentEmail.response
          if (response && response.success) {
            this.verificationSuccess = true
          } else {
            this.verificationError = true
            this.errorMessage = (response && response.message) || 'Verifizierung fehlgeschlagen'
          }
        } else {
          const error = this.$store.state.orderFormService.latestRequests.verifyStudentEmail.error
          this.verificationError = true
          this.errorMessage = (error && error.message) || 'Ein Fehler ist bei der Verifizierung aufgetreten'
        }
      } catch (error) {
        console.error('Verification error:', error)
        this.verificationError = true
        this.errorMessage = 'Ein Fehler ist bei der Verifizierung aufgetreten'
      } finally {
        this.verifying = false
      }
    }
  }
}
</script>

<style scoped>
.card {
  margin: 20px auto;
  max-width: 600px;
}

.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

.background-login {
  min-height: 100vh;
}

.vertical-center {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.emoji-icon {
  font-size: 3rem;
  line-height: 1;
}
</style>
